// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.CancelTicket_dashboard__5u4hM {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
}

.CancelTicket_dashboardContain__lDty5 {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.CancelTicket_bodythemedark__axtZ\\+ .CancelTicket_dashboardContain__lDty5,
.CancelTicket_bodythemedark__axtZ\\+ .CancelTicket_dashboard__5u4hM,
.CancelTicket_bodythemedark__axtZ\\+ .CancelTicket_cont2__ylJGe {
  background-Color: #0f1824;
}

.CancelTicket_top_header__KiY54 .CancelTicket_top_header_inner__gq7eq {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.CancelTicket_cont2__ylJGe {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /*height: calc(100vh - 160px);*/
  height: 100%;
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.CancelTicket_subLink__O6Apd svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.CancelTicket_cst_vendr__vQtxw input {
  min-height: 35px !important;
}

.CancelTicket_cst_vendr__vQtxw .CancelTicket_form-control__8-XXQ {
  background-color: #f5f6fa;
  border: none;
}

.CancelTicket_footer__eIluR {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.CancelTicket_bodythemelight__nIVsX {
  background-color: #fff;
  padding-top: 90px;
}

.CancelTicket_bodythemedark__axtZ\\+ {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.CancelTicket_headerthemelight__yaWXB {
  background-color: #fff;
}

.CancelTicket_headerthemedark__gskBk {
  background-color: #132337;
}

.CancelTicket_top_header__KiY54 {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.CancelTicket_menuthemelight__pFyrx {
  background-color: #fff;
}

.CancelTicket_menuthemedark__FLKi8 {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.CancelTicket_menulinklight__wNaRy span {
  color: #666666 !important;
}

.CancelTicket_menulinklight__wNaRy a {
  color: #CBCBCB !important;
}

.CancelTicket_menulinklight__wNaRy:hover span,
.CancelTicket_menulinklight__wNaRy:hover a {
  color: #fff !important;
}

.CancelTicket_menulinkdarkSelected__eHeIO {
  background-color: #1c2e45;
  color: #3b82f6;
}

.CancelTicket_menuthemelight__pFyrx .CancelTicket_menulinklightSelected__zI7uQ {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43 !important;
}

.CancelTicket_menulinkdark__AcoVg {
  color: #92afd3 !important;
}

.CancelTicket_menulinklight__wNaRy:hover {
  color: #fff !important;
  background-color: #131F43 !important;
}

.CancelTicket_menulinklight__wNaRy .CancelTicket_sub_arrow__dPOgf svg path {
  stroke: #CBCBCB !important;
}

.CancelTicket_menulinklight__wNaRy:hover .CancelTicket_sub_arrow__dPOgf svg path {
  stroke: #fff !important;
}

.CancelTicket_menulinkdark__AcoVg .CancelTicket_sub_arrow__dPOgf svg path {
  stroke: #92afd3 !important;
}

.CancelTicket_menulinkdark__AcoVg:hover .CancelTicket_sub_arrow__dPOgf svg path {
  stroke: #fff !important;
}

.CancelTicket_menulinklight__wNaRy:hover svg path,
.CancelTicket_menulinklightSelected__zI7uQ svg path {
  fill: #fff !important;
}

.CancelTicket_menulinkdark__AcoVg:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.CancelTicket_headinglight__sVw8v {
  color: #60677e;
}

.CancelTicket_headingdark__1A3bA {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.CancelTicket_searchboxlight__2NXOZ {
  background-color: #fff;
  border: none;
}

.CancelTicket_searchboxdark__Yw5g- {
  background-color: #132337;
  color: #fff;
  border: none;
}

.CancelTicket_searchboxdark__Yw5g-::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.CancelTicket_tableheadlight__3AERC {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.CancelTicket_tableheadlight__3AERC th {
  color: #fff;
}

thead .CancelTicket_tableheadlight__3AERC th:first-child,
thead .CancelTicket_tableheaddark__EHDr0 th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .CancelTicket_tableheadlight__3AERC th:last-child,
thead .CancelTicket_tableheaddark__EHDr0 th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.CancelTicket_table__9ziVg.CancelTicket_table-borderless__ka\\+8Y {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.CancelTicket_tableheaddark__EHDr0 {
  background-color: #132337;
  color: #fff;
}

.CancelTicket_table-borderless__ka\\+8Y tr:nth-child(even) {
  background-color: #F9FAFB;
}

.CancelTicket_table-borderless__ka\\+8Y .CancelTicket_left-section__SadkZ {
  padding-top: 10px;
}

.CancelTicket_tablebodylight__2Vnzo td,
.CancelTicket_tablebodydark__i0qez td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.CancelTicket_tablebodylight__2Vnzo {
  background-color: #fff;
}
.CancelTicket_tablebodylight__2Vnzo:hover {
  background-color: #fff;
  cursor: auto;
}

.CancelTicket_tablebodydark__i0qez {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.CancelTicket_tablebodydark__i0qez:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.CancelTicket_paginationlight__8q10Q {
  color: #60677e !important;
  font-size: 13px !important;
}

.CancelTicket_paginationdark__Yt9pG {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.CancelTicket_formthemelight__BO0Ab {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.CancelTicket_formthemedark__4Tqq2 {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.CancelTicket_formthemedark__4Tqq2 ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.CancelTicket_viewformlight__d8sZc {
  background-color: #f3f6f9;
}

.CancelTicket_permissionboxlight__kA0ii {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.CancelTicket_permissionboxdark__cpQUH {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.CancelTicket_errormsgclr__izXlI {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.CancelTicket_graphclrlight__78S0U {
  background-color: #fff;
}

.CancelTicket_graphclrdark__n-afR {
  background-color: #132337;
}

/* 
Counter theme
*/
#CancelTicket_card1bglight__SJ\\+Tr {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#CancelTicket_card1bgdark__0x5QL {
  background: #392f28;
}

#CancelTicket_card2bglight__MLD7R {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#CancelTicket_card2bgdark__l\\+WD4 {
  background: #1c3238;
}

#CancelTicket_card3bglight__xPDTA {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#CancelTicket_card3bgdark__mdySE {
  background: #3a2434;
}

#CancelTicket_card4bglight__AHh8H {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#CancelTicket_card4bgdark__1bFJd {
  background: #2f264f;
}

#CancelTicket_card1bgdark__0x5QL a,
#CancelTicket_card1bgdark__0x5QL p,
#CancelTicket_card2bgdark__l\\+WD4 a,
#CancelTicket_card2bgdark__l\\+WD4 p,
#CancelTicket_card3bgdark__mdySE a,
#CancelTicket_card3bgdark__mdySE p,
#CancelTicket_card4bgdark__1bFJd a,
#CancelTicket_card4bgdark__1bFJd p {
  color: #fff;
}

/* 
Action button theme
*/
.CancelTicket_actionbtnlight__ghiRt {
  color: rgba(70, 71, 91, 0.8705882353);
}

.CancelTicket_actionbtndark__EdS2o {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.CancelTicket_profiledropdownlight__sLu3- {
  background-color: #fff;
}

.CancelTicket_profiledropdowndark__fNuaU {
  background-color: #151521;
}

.CancelTicket_settingsection__9VG0X #CancelTicket_addform__HhJeW.CancelTicket_formthemedark__4Tqq2 .CancelTicket_savebtn__D9P0J {
  background-color: #3b82f6;
  color: #fff;
}

#CancelTicket_addform__HhJeW.CancelTicket_formthemedark__4Tqq2 .CancelTicket_savebtn__D9P0J {
  background-color: #3b82f6;
  color: #fff;
}

.CancelTicket_profile_conatiner__pDf8u {
  border-radius: 5px !important;
}

.CancelTicket_bodythemedark__axtZ\\+ .CancelTicket_ag-theme-alpine__Z01Fn .CancelTicket_ag-row__c2V3B {
  background: #000 !important;
}

.CancelTicket_bodythemedark__axtZ\\+ .CancelTicket_formbtn__9x1yB {
  background-color: #3b82f6;
}

.CancelTicket_bodythemedark__axtZ\\+ .CancelTicket_formbtn__9x1yB:hover {
  background-color: #2563eb;
}

.CancelTicket_bodythemedark__axtZ\\+ .CancelTicket_resetbtn__c4aa5 {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.CancelTicket_headingdark__1A3bA span {
  background-color: #132337;
}

.CancelTicket_resetbtn__c4aa5 {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px !important;
}

.CancelTicket_resetbtn__c4aa5:hover,
.CancelTicket_resetbtn__c4aa5:active,
.CancelTicket_resetbtn__c4aa5:focus {
  background-color: #131F43 !important;
  color: #fff !important;
}

.CancelTicket_addBtn__oj2aE {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.CancelTicket_addDltBtn__uw17P {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.CancelTicket_addbtnlight__nnd0O {
  background-color: #38A169;
}

.CancelTicket_addbtndark__I3Kkk {
  background-color: #3b82f6;
}

.CancelTicket_addbtndark__I3Kkk:hover {
  background-color: #2563eb;
}

.CancelTicket_formthemedark__4Tqq2 label {
  color: #92afd3;
}

.CancelTicket_addBtn__oj2aE svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.CancelTicket_addBtn__oj2aE:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.CancelTicket_cust_addBtn__-6R3s.CancelTicket_addBtn__oj2aE svg {
  top: 2px;
}

.CancelTicket_deleteBtn__JPuDy {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.CancelTicket_deleteBtn__JPuDy:active,
.CancelTicket_deleteBtn__JPuDy:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.CancelTicket_deleteBtn__JPuDy svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.CancelTicket_deleteBtn__JPuDy:hover,
.CancelTicket_deleteBtn__JPuDy:active,
.CancelTicket_deleteBtn__JPuDy:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.CancelTicket_confirmBtn__5X7bu {
  min-width: 130px !important;
  height: 50px !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
  background-color: #131F43 !important;
}

.CancelTicket_confirmBtn__5X7bu:active,
.CancelTicket_confirmBtn__5X7bu:focus {
  background-color: #131F43 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.CancelTicket_confirmBtn__5X7bu:hover,
.CancelTicket_confirmBtn__5X7bu:active,
.CancelTicket_confirmBtn__5X7bu:focus {
  background-color: #0f1824 !important;
}

.CancelTicket_confirmBtn__5X7bu svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.CancelTicket_delPopContainer__Yem9O .CancelTicket_modal-body__JbOba {
  padding: 35px;
  text-align: center;
}

.CancelTicket_delPopContainer__Yem9O .CancelTicket_delet_icon__IWE4P {
  margin-bottom: 11px;
}

.CancelTicket_delPopContainer__Yem9O p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
  padding: 0 20px;
}

.CancelTicket_arrowback__41BUk svg {
  fill: #000;
}

.CancelTicket_bodythemedark__axtZ\\+ .CancelTicket_arrowback__41BUk {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.CancelTicket_bodythemedark__axtZ\\+ .CancelTicket_arrowback__41BUk svg {
  fill: #3b82f6;
}

.CancelTicket_bodythemedark__axtZ\\+ .CancelTicket_drpdwn_btn__ihqfw {
  background-color: #132337;
}

.CancelTicket_bodythemedark__axtZ\\+ .CancelTicket_empname__GdUZM {
  color: #92afd3 !important;
}

.CancelTicket_bodythemedark__axtZ\\+ .CancelTicket_navitemli__ax5\\+M a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.CancelTicket_bodythemedark__axtZ\\+ .CancelTicket_tabnavli__Bqqe\\+ a.CancelTicket_settingsgeneral__q0q\\+D,
.CancelTicket_bodythemedark__axtZ\\+ .CancelTicket_tabnavli__Bqqe\\+ a.CancelTicket_settingslinks__YUKYj:hover {
  background-color: #3b82f6;
  color: #fff;
}

.CancelTicket_bodythemedark__axtZ\\+ .CancelTicket_tabnavli__Bqqe\\+ a.CancelTicket_settingslinks__YUKYj {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.CancelTicket_headerthemedark__gskBk .CancelTicket_dropdown_menu_contain__np6bz {
  background-color: #1c2e45;
  color: #fff;
}

.CancelTicket_headerthemedark__gskBk .CancelTicket_dropdown_menu_contain__np6bz ul li a,
.CancelTicket_headerthemedark__gskBk .CancelTicket_dropdown_menu_contain__np6bz .CancelTicket_dropdown_item__XtxVr,
.CancelTicket_headerthemedark__gskBk .CancelTicket_dropdown_menu_contain__np6bz .CancelTicket_dropdown_item__XtxVr h5 {
  color: #fff;
}

.CancelTicket_headerthemedark__gskBk .CancelTicket_dropdown_menu_contain__np6bz ul li a:hover,
.CancelTicket_headerthemedark__gskBk .CancelTicket_dropdown_menu_contain__np6bz .CancelTicket_dropdown_item__XtxVr:hover {
  background-color: #132337;
  color: #fff;
}

.CancelTicket_dropdown_item__XtxVr:active {
  background-color: #F5F6FA;
}

.CancelTicket_profile_arrrow_dwn__yL0lK {
  stroke: #132337;
}

.CancelTicket_headerthemedark__gskBk .CancelTicket_profile_arrrow_dwn__yL0lK {
  stroke: #fff;
}

.CancelTicket_dateinputbox1__G60Y- input,
.CancelTicket_dateinputbox1__G60Y- span {
  color: #fff !important;
}

/* LOGOUT MODAL */
.CancelTicket_delPopContainer__Yem9O .CancelTicket_modal-content__UPBxN {
  border-radius: 10px;
  min-width: 399px;
}

.CancelTicket_larg_model__556Ss .CancelTicket_modal-dialog__kI2UO {
  max-width: 100% !important;
}

.CancelTicket_larg_model__556Ss .CancelTicket_modal-content__UPBxN {
  /* display: inline-block; */
  height: 100%;
  max-width: 900px;
  margin: auto;
  border-radius: 54px !important;
  background: #FFF;
  padding: 53px 53px 23px;
}

.CancelTicket_larg_model__556Ss .CancelTicket_modal-header__wxech {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
  display: block;
}

body .CancelTicket_btn-primary__NFVZV:hover {
  background-color: transparent;
  border-color: #131F43;
  color: #131F43;
  fill: #131F43;
  border: 1px solid;
}

.CancelTicket_form-select__zIlix {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

thead .CancelTicket_CustomTable_tableheadlight__HuHZw__bCAuL th:first-child,
thead .CancelTicket_CustomTable_tableheaddark__nwqb4__-Y1DG th:first-child {
  border-radius: 5px 0 0 0px;
  display: math;
}

th:first-child {
  border-radius: 0px;
}

@media only screen and (max-width: 1200px) {
  .CancelTicket_tableheadlight__3AERC th {
    min-width: 170px;
  }
}
@media only screen and (max-width: 1024px) {
  .CancelTicket_dashboard__5u4hM {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
    overflow-x: hidden;
  }
  .CancelTicket_cont2__ylJGe {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
  /*.tableheadlight th {
    min-width: 200px !important;
  }*/
}
@media only screen and (max-width: 767px) {
  .CancelTicket_sectionright__kaW6L {
    float: unset !important;
  }
  .CancelTicket_formthemelight__BO0Ab {
    padding: 10px 0 !important;
    box-shadow: none !important;
  }
  .CancelTicket_dashboard__5u4hM {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .CancelTicket_cont2__ylJGe {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px 10px 15px !important;
  }
  .CancelTicket_bodythemelight__nIVsX,
.CancelTicket_bodythemedark__axtZ\\+ {
    padding-top: 110px;
  }
  .CancelTicket_delPopContainer__Yem9O .CancelTicket_modal-content__UPBxN {
    min-width: 100%;
  }
  .CancelTicket_delPopContainer__Yem9O .CancelTicket_modal-body__JbOba {
    padding: 15px;
  }
  .CancelTicket_larg_model__556Ss .CancelTicket_modal-content__UPBxN {
    border-radius: 20px !important;
    padding: 22px;
  }
}
@media (min-width: 576px) {
  .CancelTicket_exer_modal_contain__ol6zd .CancelTicket_modal-dialog__kI2UO {
    max-width: 1055px;
  }
  .CancelTicket_delPopContainer__Yem9O .CancelTicket_modal-dialog__kI2UO {
    max-width: 350px;
  }
  /*.tableheadlight th {
    min-width: 200px;
  }*/
}
/* vk new changes */
.CancelTicket_active_show_outer__HWJTY h2 {
  color: var(--Font-black, #0B0D0F);
  font-family: "Plus Jakarta Sans", "Lufga", sans-serif !important;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.CancelTicket_active_show_outer__HWJTY .CancelTicket_active_show_inner__Qbsds {
  width: 100%;
  display: block;
}
.CancelTicket_active_show_outer__HWJTY .CancelTicket_active_show_inner__Qbsds .CancelTicket_act_box_img__TB0Rm {
  margin-bottom: 12px;
  min-height: 400px;
  object-fit: cover;
  overflow: hidden;
  height: 400px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .CancelTicket_active_show_outer__HWJTY .CancelTicket_active_show_inner__Qbsds .CancelTicket_act_box_img__TB0Rm {
    min-height: 300px;
    height: 300px;
    max-height: 300px;
  }
}
.CancelTicket_active_show_outer__HWJTY .CancelTicket_active_show_inner__Qbsds .CancelTicket_act_box_img__TB0Rm img {
  max-height: 400px;
  /* align-self: stretch; */
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.CancelTicket_active_show_outer__HWJTY .CancelTicket_active_show_inner__Qbsds .CancelTicket_act_box_cnt__W3sIa {
  width: 100%;
  display: block;
}
.CancelTicket_active_show_outer__HWJTY .CancelTicket_active_show_inner__Qbsds .CancelTicket_act_box_cnt__W3sIa svg {
  flex-shrink: 0;
}
.CancelTicket_active_show_outer__HWJTY .CancelTicket_active_show_inner__Qbsds .CancelTicket_act_box_cnt__W3sIa .CancelTicket_act_box_bdg__lxxqb {
  width: 100%;
  margin-bottom: 12px;
}
.CancelTicket_active_show_outer__HWJTY .CancelTicket_active_show_inner__Qbsds .CancelTicket_act_box_cnt__W3sIa .CancelTicket_act_box_bdg__lxxqb span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
  width: 111px;
  display: block;
  height: 34px;
  color: var(--White, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  padding: 3px 8px;
}
.CancelTicket_active_show_outer__HWJTY .CancelTicket_active_show_inner__Qbsds .CancelTicket_act_box_cnt__W3sIa .CancelTicket_act_box_bdg__lxxqb .CancelTicket_sold__bk14K {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
}
.CancelTicket_active_show_outer__HWJTY .CancelTicket_active_show_inner__Qbsds .CancelTicket_act_box_cnt__W3sIa h3 {
  color: var(--Secondary, #132941);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.304px;
  margin: 0;
}
.CancelTicket_active_show_outer__HWJTY .CancelTicket_active_show_inner__Qbsds .CancelTicket_act_box_cnt__W3sIa p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.CancelTicket_active_show_outer__HWJTY .CancelTicket_active_show_inner__Qbsds .CancelTicket_act_box_cnt__W3sIa p span {
  color: var(--Light-1, #736B66);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.304px;
}

/* vk new changes */
.CancelTicket_attent_details__3aOQn .CancelTicket_attent_details_inner__4myap {
  display: flex;
  gap: 61px;
  padding: 20px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  align-items: center;
}
@media (max-width: 576px) {
  .CancelTicket_attent_details__3aOQn .CancelTicket_attent_details_inner__4myap {
    display: block !important;
  }
}
@media (max-width: 992px) {
  .CancelTicket_attent_details__3aOQn .CancelTicket_attent_details_inner__4myap {
    display: flex;
    gap: 20px;
    align-items: start;
  }
}
.CancelTicket_attent_details__3aOQn .CancelTicket_attent_details_inner__4myap .CancelTicket_attent_details_inner_l__E0S30 img {
  width: 187px;
  height: 207px;
  flex-shrink: 0;
  object-fit: contain;
}
@media screen and (max-width: 767px) {
  .CancelTicket_attent_details__3aOQn .CancelTicket_attent_details_inner__4myap .CancelTicket_attent_details_inner_l__E0S30 img {
    object-fit: contain;
    width: auto;
  }
}
.CancelTicket_attent_details__3aOQn .CancelTicket_attent_details_inner__4myap .CancelTicket_attent_details_inner_r__fet33 {
  flex: 1 1;
}
.CancelTicket_attent_details__3aOQn .CancelTicket_attent_details_inner__4myap .CancelTicket_attent_details_inner_r__fet33 .CancelTicket_attent_details_row__AeKB- {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
@media (max-width: 992px) {
  .CancelTicket_attent_details__3aOQn .CancelTicket_attent_details_inner__4myap .CancelTicket_attent_details_inner_r__fet33 .CancelTicket_attent_details_row__AeKB- {
    margin-bottom: 0px;
    display: inline-block;
    width: 100%;
  }
}
.CancelTicket_attent_details__3aOQn .CancelTicket_attent_details_inner__4myap .CancelTicket_attent_details_inner_r__fet33 .CancelTicket_attent_details_row__AeKB- .CancelTicket_attent_details_row_box__0adcS {
  flex: 1 1;
  width: 22%;
}
@media (max-width: 576px) {
  .CancelTicket_attent_details__3aOQn .CancelTicket_attent_details_inner__4myap .CancelTicket_attent_details_inner_r__fet33 .CancelTicket_attent_details_row__AeKB- .CancelTicket_attent_details_row_box__0adcS {
    margin: 15px 0px 10px !important;
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .CancelTicket_attent_details__3aOQn .CancelTicket_attent_details_inner__4myap .CancelTicket_attent_details_inner_r__fet33 .CancelTicket_attent_details_row__AeKB- .CancelTicket_attent_details_row_box__0adcS {
    margin-bottom: 15px;
    float: left;
    margin-right: 0;
    width: 50%;
    padding-right: 10px;
  }
}
.CancelTicket_attent_details__3aOQn .CancelTicket_attent_details_inner__4myap .CancelTicket_attent_details_inner_r__fet33 .CancelTicket_attent_details_row__AeKB- .CancelTicket_attent_details_row_box__0adcS p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.CancelTicket_attent_details__3aOQn .CancelTicket_attent_details_inner__4myap .CancelTicket_attent_details_inner_r__fet33 .CancelTicket_attent_details_row__AeKB- .CancelTicket_attent_details_row_box__0adcS h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.CancelTicket_attent_details__3aOQn .CancelTicket_attent_details_inner__4myap .CancelTicket_attent_details_inner_r__fet33 .CancelTicket_attent_details_row_last__IAkGr {
  margin-bottom: 0px !important;
}
.CancelTicket_attent_details__3aOQn .CancelTicket_attent_details_inner__4myap .CancelTicket_attent_details_inner_r__fet33 .CancelTicket_attent_details_row_last__IAkGr.CancelTicket_interesting_fact__qfAsO {
  padding-top: 30px;
}
.CancelTicket_attent_details__3aOQn .CancelTicket_attent_details_inner__4myap .CancelTicket_attent_details_inner_r__fet33 .CancelTicket_attent_details_row_last__IAkGr.CancelTicket_interesting_fact__qfAsO .CancelTicket_attent_details_row_box__0adcS {
  width: 100%;
}
.CancelTicket_attent_details__3aOQn .CancelTicket_attent_details_inner__4myap .CancelTicket_attent_details_inner_r__fet33 .CancelTicket_attent_details_row_last__IAkGr.CancelTicket_interesting_fact__qfAsO .CancelTicket_attent_details_row_box__0adcS h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.CancelTicket_showbox_sec__pwvwI {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
  align-items: stretch;
  width: 100%;
}
@media screen and (max-width: 500px) {
  .CancelTicket_showbox_sec__pwvwI {
    grid-template-columns: 1fr;
  }
}

.CancelTicket_show_box_main__0tgty {
  margin: 10px 0px;
  width: 100%;
}
.CancelTicket_show_box_main__0tgty .CancelTicket_show_box__WQXV- {
  min-height: 600px;
  width: 100%;
  margin-bottom: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
@media (max-width: 767px) {
  .CancelTicket_show_box_main__0tgty .CancelTicket_show_box__WQXV- {
    min-height: 500px;
  }
}
.CancelTicket_show_box_main__0tgty .CancelTicket_show_box__WQXV- .CancelTicket_active_show_inner__Qbsds {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}
.CancelTicket_show_box_main__0tgty .CancelTicket_show_box__WQXV- .CancelTicket_act_box_img__TB0Rm {
  flex-shrink: 0;
}
.CancelTicket_show_box_main__0tgty .CancelTicket_show_box__WQXV- .CancelTicket_act_box_cnt__W3sIa {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.CancelTicket_show_box_main__0tgty .CancelTicket_show_box__WQXV- img {
  max-height: 400px;
  height: 100%;
  width: 100%;
  object-fit: cover;
}
@media (max-width: 767px) {
  .CancelTicket_show_box_main__0tgty .CancelTicket_show_box__WQXV- img {
    max-height: 300px !important;
  }
}
.CancelTicket_show_box_main__0tgty .CancelTicket_show_box__WQXV-:last-child {
  margin-right: 0;
}
.CancelTicket_show_box_main__0tgty .CancelTicket_no_show_box__RhYku {
  width: 350px;
  margin: 0 auto 20px;
  display: block;
}
@media (max-width: 767px) {
  .CancelTicket_show_box_main__0tgty .CancelTicket_no_show_box__RhYku {
    width: 250px !important;
  }
}
.CancelTicket_show_box_main__0tgty .CancelTicket_no_show_box__RhYku img {
  max-height: 450px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .CancelTicket_show_box_main__0tgty .CancelTicket_no_show_box__RhYku img {
    max-height: 350px !important;
  }
}
.CancelTicket_show_box_main__0tgty .CancelTicket_no_show_box__RhYku h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .CancelTicket_show_box_main__0tgty .CancelTicket_no_show_box__RhYku h6 {
    font-size: 20px;
  }
}

.CancelTicket_attent_flex__xBI9J {
  justify-content: space-between !important;
  gap: 30px;
  align-items: center;
}
.CancelTicket_attent_flex__xBI9J h5 {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}

.CancelTicket_resetbtn__c4aa5 {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px;
  min-height: 50px;
  margin-right: 24px;
}
.CancelTicket_resetbtn__c4aa5:hover {
  background-color: #131F43 !important;
  border: solid 1px #131F43 !important;
  color: #fff !important;
}

.CancelTicket_resetbtn__c4aa5 svg {
  margin-right: 10px;
  position: relative;
  top: -1px;
}

.CancelTicket_resetbtn__c4aa5:hover svg,
.CancelTicket_resetbtn__c4aa5:active svg,
.CancelTicket_resetbtn__c4aa5:focus svg {
  fill: #fff;
}

.CancelTicket_deleteBtn__JPuDy {
  background-color: #F94747 !important;
  border-color: #F94747 !important;
}
.CancelTicket_deleteBtn__JPuDy:hover {
  color: #fff !important;
}

@media only screen and (max-width: 360px) {
  .CancelTicket_resetbtn__c4aa5 {
    min-width: 100px;
    margin-right: 15px;
  }
  .CancelTicket_deleteBtn__JPuDy {
    min-width: 100px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/CancelTicket/CancelTicket.module.scss"],"names":[],"mappings":"AAAA;;EAAA;AAmDC;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA3FO;EA4FP,gBAAA;ACxEH;;AD2EC;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACxEH;;AD2EC;;;EAGE,yBAnEoB;ACLvB;;AD2EC;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACxEH;;AD2EC;;CAAA;AAIA;EACE,wBAzCU;EA0CV,UAzCS;EA0CT,kBAAA;EACA,aAjDiB;EAkDjB,kBAAA;EACA,mBA3HO;EA4HP,+BAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ACtEH;;AD4EC;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACzEH;;AD8EC;EACE,2BAAA;AC3EH;;AD8EC;EACE,yBAAA;EACA,YAAA;AC3EH;;AD+EC;EACE,YAAA;AC5EH;;AD+EC;EACE,sBA9GY;ACkCf;;AD+EC;;CAAA;AAGA;EACE,sBArHY;EAsHZ,iBAAA;AC5EH;;AD+EC;EACE,yBArIgB;EAsIhB,iBAAA;AC5EH;;AD+EC;;CAAA;AAGA;EACE,sBAlIY;ACsDf;;AD+EC;EACE,yBAjJgB;ACqEnB;;AD+EC;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AC5EH;;AD+EC;;CAAA;AAGA;EACE,sBAvJY;AC2Ef;;AD+EC;EACE,yBAtKgB;AC0FnB;;AD+EC;;CAAA;AAGA;EACE,yBAAA;AC5EH;;AD+EC;EACE,yBAAA;AC5EH;;AD+EC;;EAEE,sBAAA;AC5EH;;AD+EC;EACE,yBAxLsB;EAyLtB,cAnMkB;ACuHrB;;AD+EC;EACE,sCAAA;EACA,sBAAA;EACA,oCAAA;AC5EH;;AD+EC;EACE,yBAAA;AC5EH;;AD+EC;EACE,sBAAA;EACA,oCAAA;AC5EH;;AD+EC;EACE,0BAAA;AC5EH;;AD+EC;EACE,uBAAA;AC5EH;;AD+EC;EACE,0BAAA;AC5EH;;AD+EC;EACE,uBAAA;AC5EH;;AD+EC;;EAEE,qBAAA;AC5EH;;AD+EC;EACE,yBAjOsB;EAkOtB,WAzNY;AC6If;;AD+EC;;CAAA;AAGA;EACE,cA7Ne;ACiJlB;;AD+EC;EACE,cAjOe;ACqJlB;;AD+EC;;CAAA;AAGA;EACE,sBA3OY;EA4OZ,YAAA;AC5EH;;AD+EC;EACE,yBA3PgB;EA4PhB,WAjPY;EAkPZ,YAAA;AC5EH;;AD+EC;EACE,cAnPe;ACuKlB;;AD+EC;;CAAA;AAGA;EACE,yBA3Sc;EA4Sd,8BAAA;AC5EH;;AD+EC;EACE,WAlQY;ACsLf;;AD+EC;;EAEE,0BAAA;AC5EH;;AD+EC;;EAEE,0BAAA;AC5EH;;AD+EC;EACE,kBAAA;AC5EH;;AD+EC;EACE,kBAAA;AC5EH;;AD+EC;EACE,oCAAA;EACA,gCAAA;AC5EH;;AD+EC;EACE,yBArRkB;EAsRlB,WA9RY;ACkNf;;AD+EC;EACE,yBAAA;AC5EH;;AD+EC;EACE,iBAAA;AC5EH;;AD+EC;;EAEE,+BAAA;EACA,iBAAA;AC5EH;;AD+EC;EACE,sBAhTY;ACoOf;AD8EG;EACE,sBAnTU;EAoTV,YAAA;AC5EL;;ADgFC;EACE,0CAAA;EACA,cAvTe;AC0OlB;AD+EG;EACE,yCAAA;EACA,eAAA;AC7EL;;ADiFC;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC9EH;;ADiFC;EACE,yBAAA;EACA,0BAAA;AC9EH;;ADiFC;;CAAA;AAGA;EACE,sBAnVY;EAoVZ,yBAAA;EACA,qDAAA;AC9EH;;ADiFC;EACE,yBAjVkB;EAkVlB,yBAAA;EACA,eAAA;AC9EH;ADgFG;EACE,cA3Va;AC6QlB;;ADmFC;;CAAA;AAGA;EACE,yBA1WgB;AC0RnB;;ADmFC;EACE,yBAAA;EACA,yBAAA;AChFH;;ADmFC;EACE,yBA1XoB;EA2XpB,yBAAA;AChFH;;ADmFC;EACE,UAAA;EACA,eAAA;EACA,eAAA;AChFH;;ADmFC;;CAAA;AAGA;EACE,sBA9XY;AC8Sf;;ADmFC;EACE,yBA1XkB;AC0SrB;;ADoFC;;CAAA;AAGA;EACE,iGAAA;EACA,sBA3YY;AC0Tf;;ADoFC;EACE,mBAAA;ACjFH;;ADoFC;EACE,gGAAA;EACA,sBApZY;ACmUf;;ADoFC;EACE,mBAAA;ACjFH;;ADoFC;EACE,gGAAA;EACA,sBA7ZY;AC4Uf;;ADoFC;EACE,mBAAA;ACjFH;;ADoFC;EACE,gGAAA;EACA,sBAtaY;ACqVf;;ADoFC;EACE,mBAAA;ACjFH;;ADoFC;;;;;;;;EAQE,WArbY;ACoWf;;ADoFC;;CAAA;AAGA;EACE,qCAAA;ACjFH;;ADoFC;EACE,cA7be;AC4WlB;;ADqFC;;CAAA;AAGA;EACE,sBAAA;AClFH;;ADqFC;EACE,yBAAA;AClFH;;ADqFC;EACE,yBAjekB;EAkelB,WAjdY;AC+Xf;;ADqFC;EACE,yBAtekB;EAuelB,WAtdY;ACoYf;;ADqFC;EACE,6BAAA;AClFH;;ADqFC;EACE,2BAAA;AClFH;;ADqFC;EACE,yBAnfkB;ACiarB;;ADqFC;EACE,yBAtfwB;ACoa3B;;ADqFC;EACE,WA1eY;EA2eZ,6BAAA;EACA,yBAAA;AClFH;;ADsFC;EACE,yBA5fgB;ACyanB;;ADsFC;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;ACnFH;;ADsFC;;;EAGE,oCAAA;EACA,sBAAA;ACnFH;;ADsFC;EACE,gBAAA;EACA,YAAA;EACA,WAxgBY;EAygBZ,yBAriBY;EAsiBZ,YAAA;EACA,eAAA;EACA,gBAhkBc;AC6ejB;;ADsFE;EACC,gBAAA;EACA,YAAA;EACA,WAlhBY;EAmhBZ,yBA/iBY;EAgjBZ,YAAA;EACA,eAAA;EACA,gBA1kBc;ACufjB;;ADsFC;EACE,yBAtjBY;ACmef;;ADsFC;EACE,yBA/iBkB;AC4drB;;ADsFC;EACE,yBAljBwB;AC+d3B;;ADsFC;EACE,cAxjBiB;ACqepB;;ADuFC;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpFH;;ADuFC;EACE,WAjjBY;EAkjBZ,yBA9kBY;EA+kBZ,YAAA;ACpFH;;ADuFC;EACE,QAAA;ACpFH;;ADwFC;EACE,gBAAA;EACA,YAAA;EACA,yBAnlBW;EAolBX,WA/jBY;EAgkBZ,eAAA;EACA,gBArnBc;EAsnBd,YAAA;ACrFH;;ADwFC;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACrFH;;ADwFC;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACrFH;;ADwFC;;;EAGE,yBA1mBW;EA2mBX,WAtlBY;EAulBZ,YAAA;ACrFH;;ADwFC;EACC,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,oCAAA;ACrFF;;ADwFC;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACrFH;;ADwFC;;;EAGE,oCAAA;ACrFH;;ADwFC;EACC,kBAAA;EACA,kBAAA;EACA,SAAA;ACrFF;;AD0FC;EACE,aAAA;EACA,kBAAA;ACvFH;;AD0FC;EACE,mBAAA;ACvFH;;AD0FC;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACvFH;;AD0FC;EACE,UAAA;ACvFH;;AD0FC;EACE,yCA7pBc;EA8pBd,cAlqBkB;AC2kBrB;;AD0FC;EACE,aAtqBkB;AC+kBrB;;AD0FC;EACE,yBAlqBgB;AC2kBnB;;AD0FC;EACE,yBAAA;ACvFH;;AD0FC;EACE,6BAAA;EACA,yBAAA;EACA,WAjqBY;AC0kBf;;AD0FC;;EAEE,yBAvrBkB;EAwrBlB,WAvqBY;ACglBf;;AD0FC;EACE,6BAAA;EACA,yBAAA;EACA,WA7qBY;ACslBf;;AD0FC;EACE,yBA1rBsB;EA2rBtB,WAlrBY;AC2lBf;;AD0FC;;;EAGE,WAxrBY;ACimBf;;AD0FC;;EAEE,yBAxsBgB;EAysBhB,WA9rBY;ACumBf;;AD0FC;EACE,yBAjvBO;AC0pBV;;AD0FC;EACE,eAjtBgB;AC0nBnB;;AD0FC;EACE,YA1sBY;ACmnBf;;AD0FC;;EAEE,sBAAA;ACvFH;;AD0FC,iBAAA;AAKA;EACE,mBAAA;EACA,gBAAA;AC3FH;;AD8FC;EACE,0BAAA;AC3FH;;AD8FC;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;AC3FH;;AD8FC;EACE,qBAAA;EACA,iCAAA;EACA,cAAA;AC3FH;;AD8FC;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AC3FH;;AD8FC;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oEAAA;AC3FH;;AD8FC;;EAEE,0BAAA;EACA,aAAA;AC3FH;;AD8FC;EACE,kBAAA;AC3FH;;AD8FC;EACE;IACE,gBAAA;EC3FH;AACF;AD8FC;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kBAAA;EC5FH;ED+FC;IACE,2BAAA;IACA,gBAAA;EC7FH;AACF;ADgGC;EACE;;IAAA;EAGA;;IAAA;AC5FH;ADiGC;EACE;IACE,uBAAA;EC/FH;EDiGD;IACE,0BAAA;IACA,2BAAA;EC/FD;EDiGC;IACE,6BAAA;EC/FH;AACF;ADkGC;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kCAAA;EChGH;EDmGC;;IAEE,kBAAA;ECjGH;EDoGC;IACE,eAAA;EClGH;EDqGC;IACE,aAAA;ECnGH;EDsGC;IACE,8BAAA;IACA,aAAA;ECpGH;AACF;ADuGC;EACE;IACE,iBAAA;ECrGH;EDwGC;IACE,gBAAA;ECtGH;EDyGC;;IAAA;ACrGH;AD0GC,mBAAA;AAGA;EACE,iCAAA;EACA,gEAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC1GH;AD6GG;EACE,WAAA;EACA,cAAA;AC3GL;AD6GK;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;AC3GP;AD4GO;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,iBAAA;ECzGP;AACF;AD0GO;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ACxGT;AD4GK;EACE,WAAA;EACA,cAAA;AC1GP;AD2GC;EACC,cAAA;ACzGF;AD2GO;EACE,WAAA;EACA,mBAAA;ACzGT;AD2GS;EACE,uEAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ACzGX;AD4GS;EACE,kFAAA;AC1GX;AD+GO;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AC7GT;ADgHO;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AC9GT;ADgHS;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AC9GX;;ADqHC,mBAAA;AAEE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;ACnHL;ADqHK;EATF;IAUI,yBAAA;EClHL;AACF;ADoHK;EAbF;IAcI,aAAA;IACA,SAAA;IACA,kBAAA;ECjHL;AACF;ADoHO;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AClHT;ADmHS;EALF;IAMG,mBAAA;IACA,WAAA;EChHR;AACF;ADoHK;EACE,SAAA;AClHP;ADoHO;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AClHT;ADoHS;EALF;IAMI,kBAAA;IACA,qBAAA;IACA,WAAA;ECjHT;AACF;ADmHS;EACE,SAAA;EACA,UAAA;ACjHX;ADmHW;EAJF;IAKI,gCAAA;IACA,sBAAA;EChHX;AACF;ADkHW;EATF;IAUI,mBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;EC/GX;AACF;ADiHW;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC/Gb;ADkHW;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AChHb;ADqHM;EACE,6BAAA;ACnHR;ADoHQ;EACE,iBAAA;AClHV;ADmHU;EACE,WAAA;ACjHZ;ADkHY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AChHd;;ADwHC;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,oBAAA;EACA,WAAA;ACrHH;ADsHG;EANF;IAOI,0BAAA;ECnHH;AACF;;ADqHC;EACE,gBAAA;EACA,WAAA;AClHH;ADoHG;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AClHL;ADoHK;EATF;IAUI,iBAAA;ECjHL;AACF;ADmHK;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;ACjHP;ADoHK;EACE,cAAA;AClHP;ADqHK;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;ACnHP;ADsHK;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;ACpHP;ADsHO;EANF;IAOI,4BAAA;ECnHP;AACF;ADsHK;EACE,eAAA;ACpHP;ADwHG;EACE,YAAA;EACA,mBAAA;EACA,cAAA;ACtHL;ADwHK;EALF;IAMI,uBAAA;ECrHL;AACF;ADuHK;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ACrHP;ADuHO;EALF;IAMI,4BAAA;ECpHP;AACF;ADsHK;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;ACpHP;ADqHO;EARF;IASI,eAAA;EClHP;AACF;;ADyHC;EACE,yCAAA;EACA,SAAA;EACA,mBAAA;ACtHH;ADwHG;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;ACtHL;;AAhlCA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAmlCJ;AAllCI;EACA,oCAAA;EACA,oCAAA;EACA,sBAAA;AAolCJ;;AAhlCA;EACI,kBAAA;EACA,kBAAA;EACA,SAAA;AAmlCJ;;AAhlCA;;;EAGI,UD6BW;ACsjCf;;AAhlCA;EACI,oCAAA;EACA,gCAAA;AAmlCJ;AAllCI;EACI,sBAAA;AAolCR;;AA/kCA;EACI;IACI,gBAAA;IACA,kBAAA;EAklCN;EAhlCE;IACI,gBAAA;EAklCN;AACF","sourcesContent":["/* \nscss\n */\n $font-regular: 400;\n $font-medium: 500;\n $font-semiBold: 600;\n $font-bold: 700;\n $font-extraBold: 800;\n $font-black: 900;\n \n $mainBg: #F5F6FA;\n $primary-color: #131F43;\n $icon-bgcolor: #F6F6F6;\n $text-graycolor: #727272;\n $cardIcon1-bg: #F3F4F8;\n $cardIcon1-darkbg: #30231a;\n $cardIcon1-darkbg-icon: #9d785f;\n $cardIcon2-bg: #FAF4FB;\n $cardIcon2-darkbg: #13252a;\n $cardIcon2-darkbg-icon: #3b606a;\n $cardIcon3-bg: #FAF7F3;\n $cardIcon3-darkbg: #2c1a27;\n $cardIcon3-darkbg-icon: #6c4863;\n $cardIcon4-bg: #F5F9FC;\n $cardIcon4-darkbg: #241d3e;\n $cardIcon4-darkbg-icon: #5f538b;\n $cardIcon2-color: #AC44BB;\n $cardIcon3-color: #D69A5F;\n $cardIcon4-color: #176CA5;\n $green-color: #38A169;\n $darkGreen-color: #207a4a;\n $placeholder-color: #666666;\n $profile-dark-text: #181818;\n $heading : #0B0D0F;\n $light-gray : #999999;\n $menu_icon : #CBCBCB;\n $red-color : #F94747;\n $red-hover : #960101;\n $dark-active-blue : #3b82f6;\n $dark-light-blue : #92afd3;\n $addBtn-dark-blue : #3b82f6;\n $addBtn-dark-blue-hover : #2563eb;\n $backBtn-dark : #3b82f633;\n \n \n \n $darkTheme_blue : #132337;\n $darkTheme_darkBlue : #0f1824;\n $darkTheme_selectBlue : #1c2e45;\n $darkTheme_updateBtn : #0a2574;\n \n /* \n Body Theme Color\n  */\n $lightthemecolor: #f3f6f9;\n $darkthemecolor: #151521;\n \n $white-color: #fff;\n $black-color: #1d1d1d;\n $fullBlack-color: #1d1d1d;\n $lightthemetext: #60677e;\n \n /* \n Dark Theme Colors\n */\n $primarydark-color: #132337;\n \n /* \n Button Theme\n */\n $primary-btncolor: #131F43;\n $secondary-btncolor: rgba(37, 105, 109, 0.864);\n \n $tableheadlightbg: #e9eaf0;\n \n \n /* \n Max Dashboard scss\n */\n $dashboardwidth: calc(100% - 320px);\n $dashboardposition: absolute;\n $dashboardleft: 290px;\n $dashboardpadding: 30px;\n \n /* \n Min Dashboard scss\n */\n $dashwidth: calc(100% - 50px);\n $dashleft: 50px;\n \n /* \n Max Dashboard scss\n */\n \n .dashboard {\n   width: $dashboardwidth;\n   position: relative;\n   left: $dashboardleft;\n   padding: $dashboardpadding;\n   border-radius: 8px;\n   min-height: auto !important;\n   background-color: $mainBg;\n   overflow-y: auto;\n }\n \n .dashboardContain {\n   width: calc(100% - 320px);\n   background-Color: $mainBg;\n   border-radius: 8px;\n }\n \n .bodythemedark .dashboardContain,\n .bodythemedark .dashboard,\n .bodythemedark .cont2 {\n   background-Color: $darkTheme_darkBlue;\n }\n \n .top_header .top_header_inner {\n   background-color: transparent;\n   height: auto;\n   overflow-y: unset;\n }\n \n /* \n Min Dashboard scss\n */\n \n .cont2 {\n   width: $dashwidth;\n   left: $dashleft;\n   position: relative;\n   padding: $dashboardpadding;\n   border-radius: 8px;\n   background: $mainBg;\n   /*height: calc(100vh - 160px);*/\n   height: 100%;\n   min-height: auto !important;\n   overflow-y: auto;\n   /* \n background-Color: $dashboardbackgroundColor;\n   padding-bottom: 8%;\n */\n }\n \n .subLink svg {\n   position: relative;\n   top: -2px;\n   left: -7px;\n }\n \n \n \n .cst_vendr input {\n   min-height: 35px !important;\n }\n \n .cst_vendr .form-control {\n   background-color: #f5f6fa;\n   border: none;\n }\n \n \n .footer {\n   height: 70px;\n }\n \n body {\n   background-color: $white-color;\n }\n \n /* \n THEME CHANGE\n */\n .bodythemelight {\n   background-color: $white-color;\n   padding-top: 90px;\n }\n \n .bodythemedark {\n   background-color: $darkTheme_blue;\n   padding-top: 90px;\n }\n \n /* \n Header Navbar Theme\n */\n .headerthemelight {\n   background-color: $white-color;\n }\n \n .headerthemedark {\n   background-color: $darkTheme_blue;\n }\n \n .top_header {\n   min-height: 90px;\n   display: flex;\n   align-items: center;\n   position: fixed;\n   width: 100%;\n   z-index: 2;\n   top: 0;\n }\n \n /* \n LEFT MENU THEME CHANGE\n */\n .menuthemelight {\n   background-color: $white-color;\n }\n \n .menuthemedark {\n   background-color: $darkTheme_blue;\n }\n \n /* \n LEFT MENU LINKS THEME CHANGE\n */\n .menulinklight span {\n   color: $placeholder-color !important;\n }\n \n .menulinklight a {\n   color: $menu_icon !important;\n }\n \n .menulinklight:hover span,\n .menulinklight:hover a {\n   color: $white-color !important;\n }\n \n .menulinkdarkSelected {\n   background-color: $darkTheme_selectBlue;\n   color: $dark-active-blue;\n }\n \n .menuthemelight .menulinklightSelected {\n   /*background-color: $lightthemecolor;*/\n   color: $white-color !important;\n   background-color: $primary-color !important;\n }\n \n .menulinkdark {\n   color: $dark-light-blue !important;\n }\n \n .menulinklight:hover {\n   color: $white-color !important;\n   background-color: $primary-color !important;\n }\n \n .menulinklight .sub_arrow svg path {\n   stroke: $menu_icon !important;\n }\n \n .menulinklight:hover .sub_arrow svg path {\n   stroke: $white-color !important;\n }\n \n .menulinkdark .sub_arrow svg path {\n   stroke: $dark-light-blue !important;\n }\n \n .menulinkdark:hover .sub_arrow svg path {\n   stroke: $white-color !important;\n }\n \n .menulinklight:hover svg path,\n .menulinklightSelected svg path {\n   fill: #fff !important;\n }\n \n .menulinkdark:hover {\n   background-color: $darkTheme_selectBlue;\n   color: $white-color;\n }\n \n /* \n BODY HEADERS\n */\n .headinglight {\n   color: $lightthemetext;\n }\n \n .headingdark {\n   color: $lightthemetext;\n }\n \n /* \n SEARCH BOX THEME COLOR\n */\n .searchboxlight {\n   background-color: $white-color;\n   border: none;\n }\n \n .searchboxdark {\n   background-color: $darkTheme_blue;\n   color: $white-color;\n   border: none;\n }\n \n .searchboxdark::placeholder {\n   color: $lightthemetext;\n }\n \n /* \n CUSTOM TABLE THEME COLOR\n */\n .tableheadlight {\n   background-color: $primary-color;\n   border-radius: 5px 5px 0px 0px;\n }\n \n .tableheadlight th {\n   color: $white-color;\n }\n \n thead .tableheadlight th:first-child,\n thead .tableheaddark th:first-child {\n   border-radius: 5px 0 0 0px;\n }\n \n thead .tableheadlight th:last-child,\n thead .tableheaddark th:last-child {\n   border-radius: 0 5px 0px 0;\n }\n \n th:first-child {\n   border-radius: 0px;\n }\n \n td:last-child {\n   border-radius: 0px;\n }\n \n table.table.table-borderless {\n   border-collapse: separate !important;\n   border-spacing: 0 0px !important;\n }\n \n .tableheaddark {\n   background-color: $primarydark-color;\n   color: $white-color;\n }\n \n .table-borderless tr:nth-child(even) {\n   background-color: #F9FAFB;\n }\n \n .table-borderless .left-section {\n   padding-top: 10px;\n }\n \n .tablebodylight td,\n .tablebodydark td {\n   padding: 0.5rem 1rem !important;\n   line-height: 45px;\n }\n \n .tablebodylight {\n   background-color: $white-color;\n \n   &:hover {\n     background-color: $white-color;\n     cursor: auto;\n   }\n }\n \n .tablebodydark {\n   /* background-color: $primarydark-color; */\n   color: $lightthemetext;\n \n   &:hover {\n     background-color: rgba(33, 150, 243, 0.1);\n     cursor: pointer;\n   }\n }\n \n /* \n PAGINATION THEME COLOR\n */\n .paginationlight {\n   color: $lightthemetext !important;\n   font-size: 13px !important;\n }\n \n .paginationdark {\n   color: $lightthemetext !important;\n   font-size: 13px !important;\n }\n \n /* \n SETTING FORM THEME COLOR\n */\n .formthemelight {\n   background-color: $white-color;\n   color: $black-color !important;\n   box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n }\n \n .formthemedark {\n   background-color: $primarydark-color;\n   color: $lightthemetext !important;\n   font-size: 14px;\n \n   ::placeholder {\n     color: $lightthemetext;\n   }\n }\n \n \n /* \n VIEW FORM DETAILS BOX THEME COLOR\n */\n .viewformlight {\n   background-color: $lightthemecolor;\n }\n \n .permissionboxlight {\n   background-color: #f8f9fa;\n   border: 1px solid #dee2e6;\n }\n \n .permissionboxdark {\n   background-color: $darkTheme_darkBlue;\n   border: solid 1px #242434;\n }\n \n .errormsgclr {\n   color: red;\n   font-size: 14px;\n   margin-top: 5px;\n }\n \n /* \n Graph theme\n */\n .graphclrlight {\n   background-color: $white-color;\n }\n \n .graphclrdark {\n   background-color: $primarydark-color;\n }\n \n \n /* \n Counter theme\n */\n #card1bglight {\n   /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card1bgdark {\n   background: #392f28;\n }\n \n #card2bglight {\n   /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card2bgdark {\n   background: #1c3238;\n }\n \n #card3bglight {\n   /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card3bgdark {\n   background: #3a2434;\n }\n \n #card4bglight {\n   /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card4bgdark {\n   background: #2f264f;\n }\n \n #card1bgdark a,\n #card1bgdark p,\n #card2bgdark a,\n #card2bgdark p,\n #card3bgdark a,\n #card3bgdark p,\n #card4bgdark a,\n #card4bgdark p {\n   color: $white-color;\n }\n \n /* \n Action button theme\n */\n .actionbtnlight {\n   color: #46475bde;\n }\n \n .actionbtndark {\n   color: $lightthemetext;\n }\n \n \n /* \n profile dropdowntheme\n */\n .profiledropdownlight {\n   background-color: #fff;\n }\n \n .profiledropdowndark {\n   background-color: #151521;\n }\n \n .settingsection #addform.formthemedark .savebtn {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n #addform.formthemedark .savebtn {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .profile_conatiner {\n   border-radius: 5px !important;\n }\n \n .bodythemedark .ag-theme-alpine .ag-row {\n   background: #000 !important;\n }\n \n .bodythemedark .formbtn {\n   background-color: $addBtn-dark-blue;\n }\n \n .bodythemedark .formbtn:hover {\n   background-color: $addBtn-dark-blue-hover;\n }\n \n .bodythemedark .resetbtn {\n   color: $white-color;\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n }\n \n \n .headingdark span {\n   background-color: $darkTheme_blue;\n }\n \n .resetbtn {\n   font-size: 16px !important;\n   font-weight: $font-semiBold !important;\n   border-radius: 5px !important;\n   background-color: transparent !important;\n   border: solid 1px $primary-color !important;\n   color: $primary-color !important;\n   min-width: 113px !important;\n }\n \n .resetbtn:hover,\n .resetbtn:active,\n .resetbtn:focus {\n   background-color: $primary-color !important;\n   color: $white-color !important;\n }\n \n .addBtn {\n   min-width: 140px;\n   height: 44px;\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n }\n\n  .addDltBtn {\n   min-width: 140px;\n   height: 44px;\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n }\n \n .addbtnlight {\n   background-color: $green-color;\n }\n \n .addbtndark {\n   background-color: $addBtn-dark-blue;\n }\n \n .addbtndark:hover {\n   background-color: $addBtn-dark-blue-hover;\n }\n \n .formthemedark label {\n   color: $dark-light-blue;\n }\n \n \n .addBtn svg {\n   margin-right: 10px;\n   position: relative;\n   top: 2px;\n }\n \n .addBtn:hover {\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n }\n \n .cust_addBtn.addBtn svg {\n   top: 2px;\n }\n \n \n .deleteBtn {\n   min-width: 130px;\n   height: 50px;\n   background-color: $red-color;\n   color: $white-color;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n   border: none;\n }\n \n .deleteBtn:active,\n .deleteBtn:focus {\n   background-color: $red-color !important;\n   color: $white-color !important;\n   box-shadow: none !important;\n }\n \n .deleteBtn svg {\n   margin-right: 10px;\n   position: relative;\n   top: -2px;\n }\n \n .deleteBtn:hover,\n .deleteBtn:active,\n .deleteBtn:focus {\n   background-color: $red-color;\n   color: $white-color;\n   border: none;\n }\n \n .confirmBtn {\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n  background-color: $primary-color !important;\n }\n\n .confirmBtn:active,\n .confirmBtn:focus {\n   background-color: $primary-color !important;\n   color: $white-color !important;\n   box-shadow: none !important;\n }\n \n .confirmBtn:hover,\n .confirmBtn:active,\n .confirmBtn:focus {\n   background-color: $darkTheme_darkBlue !important;\n }\n \n .confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n \n \n \n .delPopContainer .modal-body {\n   padding: 35px;\n   text-align: center;\n }\n \n .delPopContainer .delet_icon {\n   margin-bottom: 11px;\n }\n \n .delPopContainer p {\n   color: #131f43;\n   font-size: 14px;\n   font-weight: 700;\n   padding: 0 20px;\n }\n \n .arrowback svg {\n   fill: #000;\n }\n \n .bodythemedark .arrowback {\n   background-color: $backBtn-dark;\n   color: $dark-active-blue;\n }\n \n .bodythemedark .arrowback svg {\n   fill: $dark-active-blue;\n }\n \n .bodythemedark .drpdwn_btn {\n   background-color: $darkTheme_blue;\n }\n \n .bodythemedark .empname {\n   color: $dark-light-blue !important;\n }\n \n .bodythemedark .navitemli a {\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .bodythemedark .tabnavli a.settingsgeneral,\n .bodythemedark .tabnavli a.settingslinks:hover {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .bodythemedark .tabnavli a.settingslinks {\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain {\n   background-color: $darkTheme_selectBlue;\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain ul li a,\n .headerthemedark .dropdown_menu_contain .dropdown_item,\n .headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain ul li a:hover,\n .headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n   background-color: $darkTheme_blue;\n   color: $white-color;\n }\n \n .dropdown_item:active {\n   background-color: $mainBg;\n }\n \n .profile_arrrow_dwn {\n   stroke: $darkTheme_blue;\n }\n \n .headerthemedark .profile_arrrow_dwn {\n   stroke: $white-color;\n }\n \n .dateinputbox1 input,\n .dateinputbox1 span {\n   color: $white-color !important;\n }\n \n /* LOGOUT MODAL */\n .modalStyleLight {}\n \n .modalStyleDark {}\n \n .delPopContainer .modal-content {\n   border-radius: 10px;\n   min-width: 399px;\n }\n \n .larg_model .modal-dialog {\n   max-width: 100% !important;\n }\n \n .larg_model .modal-content {\n   /* display: inline-block; */\n   height: 100%;\n   max-width: 900px;\n   margin: auto;\n   border-radius: 54px !important;\n   background: #FFF;\n   padding: 53px 53px 23px;\n }\n \n .larg_model .modal-header {\n   padding: 0px 0px 23px;\n   border-bottom: 1px dashed #D4D9EE;\n   display: block;\n }\n \n body .btn-primary:hover {\n   background-color: transparent;\n   border-color: #131F43;\n   color: #131F43;\n   fill: #131F43;\n   border: 1px solid;\n }\n \n .form-select {\n   display: block;\n   width: 100%;\n   padding: .375rem 2.25rem .375rem .75rem;\n   -moz-padding-start: calc(0.75rem - 3px);\n   font-size: 1rem;\n   font-weight: 400;\n   line-height: 1.5;\n   color: #212529;\n   background-color: #fff;\n   background-image: url(../../assets/select_arow.svg) !important;\n }\n \n thead .CustomTable_tableheadlight__HuHZw th:first-child,\n thead .CustomTable_tableheaddark__nwqb4 th:first-child {\n   border-radius: 5px 0 0 0px;\n   display: math;\n }\n \n th:first-child {\n   border-radius: 0px;\n }\n \n @media only screen and (max-width: 1200px) {\n   .tableheadlight th {\n     min-width: 170px;\n   }\n }\n \n @media only screen and (max-width: 1024px) {\n   .dashboard {\n     width: calc(100% - 50px) !important;\n     left: 50px !important;\n     padding: 10px 10px !important;\n     overflow-x: hidden;\n   }\n \n   .cont2 {\n     height: calc(100vh - 160px);\n     overflow-y: auto;\n   }\n }\n \n @media only screen and (max-width: 998px) {\n   /* #dashboardcont2{\n     height: auto !important;\n   }*/\n   /*.tableheadlight th {\n     min-width: 200px !important;\n   }*/\n }\n \n @media only screen and (max-width: 767px) {\n   .sectionright {\n     float: unset !important;\n   }\n .formthemelight {\n   padding: 10px 0!important;\n   box-shadow: none !important;\n }\n   .dashboard {\n     padding: 10px 10px !important;\n   }\n }\n \n @media only screen and (max-width: 600px) {\n   .cont2 {\n     width: $dashwidth !important;\n     left: $dashleft !important;\n     position: relative !important;\n     padding: 10px 10px 15px !important;\n   }\n \n   .bodythemelight,\n   .bodythemedark {\n     padding-top: 110px;\n   }\n \n   .delPopContainer .modal-content {\n     min-width: 100%;\n   }\n \n   .delPopContainer .modal-body {\n     padding: 15px;\n   }\n \n   .larg_model .modal-content {\n     border-radius: 20px !important;\n     padding: 22px;\n   }\n }\n \n @media (min-width: 576px) {\n   .exer_modal_contain .modal-dialog {\n     max-width: 1055px;\n   }\n \n   .delPopContainer .modal-dialog {\n     max-width: 350px;\n   }\n \n   /*.tableheadlight th {\n     min-width: 200px;\n   }*/\n }\n \n /* vk new changes */\n .active_show_outer {\n \n h2 {\n   color: var(--Font-black, #0B0D0F);\n   font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n   font-size: 22px;\n   font-style: normal;\n   font-weight: 700;\n   line-height: normal;\n }\n \n   .active_show_inner {\n     width: 100%;\n     display: block;\n \n     .act_box_img {\n       margin-bottom: 12px;\n       min-height: 400px;\n       object-fit: cover;\n       overflow: hidden;\n       height: 400px;\n       max-height: 400px;\n       @media (max-width: 767px) {\n         min-height: 300px;\n         height: 300px;\n         max-height: 300px;\n       }\n       img {\n         max-height: 400px;\n         /* align-self: stretch; */\n         width: 100%;\n         height: 100%;\n         border-radius: 12px;\n         object-fit: cover;\n       }\n     }\n \n     .act_box_cnt {\n       width: 100%;\n       display: block;\n svg{\n  flex-shrink: 0;\n }\n       .act_box_bdg {\n         width: 100%;\n         margin-bottom: 12px;\n \n         span {\n           background: url(../../assets/ongoing.png) right top no-repeat;\n           width: 111px;\n           display: block;\n           height: 34px;\n           color: var(--White, #FFF);\n           font-size: 18px;\n           font-style: normal;\n           font-weight: 500;\n           padding: 3px 8px;\n         }\n \n         .sold {\n           background: url(../../assets/sold.png) right top no-repeat !important;\n         }\n \n       }\n \n       h3 {\n         color: var(--Secondary, #132941);\n         font-size: 18px;\n         font-style: normal;\n         font-weight: 600;\n         line-height: 26.304px;\n         margin: 0;\n       }\n \n       p {\n         display: flex;\n         align-items: center;\n         gap: 10px;\n         margin-bottom: 5px;\n \n         span {\n           color: var(--Light-1, #736B66);\n           font-size: 14px;\n           font-style: normal;\n           font-weight: 500;\n           line-height: 26.304px;\n         }\n       }\n     }\n   }\n }\n \n /* vk new changes */\n .attent_details {\n   .attent_details_inner {\n     display: flex;\n     gap: 61px;\n     padding: 20px;\n     border-radius: 5px;\n     background: #FFF;\n     box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n     align-items: center;\n \n     @media (max-width: 576px) {\n       display: block !important;\n     }\n \n     @media (max-width: 992px) {\n       display: flex;\n       gap: 20px;\n       align-items: start;\n     }\n \n     .attent_details_inner_l {\n       img {\n         width: 187px;\n         height: 207px;\n         flex-shrink: 0;\n         object-fit: contain;\n         @media screen and (max-width:767px) {\n          object-fit: contain;\n          width: auto;\n         }\n       }\n     }\n \n     .attent_details_inner_r {\n       flex: 1;\n \n       .attent_details_row {\n         display: flex;\n         gap: 20px;\n         margin-bottom: 28px;\n \n         @media (max-width: 992px) {\n           margin-bottom: 0px;\n           display: inline-block;\n           width: 100%;\n         }\n \n         .attent_details_row_box {\n           flex: 1;\n           width: 22%;\n \n           @media (max-width: 576px) {\n             margin: 15px 0px 10px !important;\n             width: 100% !important;\n           }\n \n           @media (max-width: 992px) {\n             margin-bottom: 15px;\n             float: left;\n             margin-right: 0;\n             width: 50%;\n             padding-right: 10px;\n           }\n \n           p {\n             margin-bottom: 10px;\n             color: #727272;\n             font-size: 13px;\n             font-style: normal;\n             font-weight: 600;\n             line-height: normal;\n           }\n \n           h5 {\n             color: #131F43;\n             font-size: 16px;\n             font-style: normal;\n             font-weight: 600;\n             line-height: normal;\n             word-wrap: break-word;\n           }\n         }\n       }\n \n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n     }\n   }\n }\n .showbox_sec {\n   display: grid;\n   grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n   gap: 20px;\n   align-items: stretch;\n   width: 100%;\n   @media screen and (max-width: 500px) {\n     grid-template-columns: 1fr;\n   }\n }\n .show_box_main {\n   margin: 10px 0px;\n   width: 100%;\n\n   .show_box {\n     min-height: 600px;\n     width: 100%;\n     margin-bottom: 0;\n     cursor: pointer;\n     display: flex;\n     flex-direction: column;\n     box-sizing: border-box;\n\n     @media (max-width: 767px) {\n       min-height: 500px;\n     }\n\n     .active_show_inner {\n       display: flex;\n       flex-direction: column;\n       flex: 1;\n       min-height: 0;\n     }\n\n     .act_box_img {\n       flex-shrink: 0;\n     }\n\n     .act_box_cnt {\n       flex: 1;\n       display: flex;\n       flex-direction: column;\n       min-height: 0;\n     }\n\n     img {\n       max-height: 400px;\n       height: 100%;\n       width: 100%;\n       object-fit: cover;\n\n       @media (max-width: 767px) {\n         max-height: 300px !important;\n       }\n     }\n\n     &:last-child {\n       margin-right: 0;\n     }\n   }\n \n   .no_show_box {\n     width: 350px;\n     margin: 0 auto 20px;\n     display: block;\n   \n     @media (max-width: 767px) {\n       width: 250px !important;\n     }\n   \n     img {\n       max-height: 450px;\n       height: 100%;\n       width: 100%;\n   \n       @media (max-width: 767px) {\n         max-height: 350px !important;\n       }\n     }\n     h6 {\n       color: #000;\n       text-align: center;\n       font-size: 26px;\n       font-style: normal;\n       font-weight: 700;\n       line-height: normal;\n       margin-top: 20px;\n       @media only screen and (max-width: 600px) {\n         font-size: 20px;\n       }\n     }\n   }\n   \n \n }\n \n .attent_flex {\n   justify-content: space-between !important;\n   gap: 30px;\n   align-items: center;\n \n   h5 {\n     font-size: 22px;\n     font-style: normal;\n     font-weight: 700;\n   }\n }\n","@import \"../../styles/Variables/Variables.scss\";\n\n.resetbtn {\n    font-size: 16px;\n    font-weight: 600;\n    border-radius: 5px;\n    background-color: transparent !important;\n    border: solid 1px $primary-color !important;\n    color: $primary-color !important;\n    min-width: 113px;\n    min-height: 50px;\n    margin-right: 24px;\n    &:hover {\n    background-color: $primary-color !important;\n    border: solid 1px $primary-color !important;\n    color: $white-color !important; \n    }\n}\n\n.resetbtn svg {\n    margin-right: 10px;\n    position: relative;\n    top: -1px;\n}\n\n.resetbtn:hover svg,\n.resetbtn:active svg,\n.resetbtn:focus svg {\n    fill: $white-color;\n}\n\n.deleteBtn {\n    background-color:$red-color !important;\n    border-color: $red-color !important;\n    &:hover {\n        color: $white-color !important;\n    }\n}\n\n\n@media only screen and (max-width: 360px) {\n    .resetbtn {\n        min-width: 100px;\n        margin-right: 15px;\n    }\n    .deleteBtn {\n        min-width: 100px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `CancelTicket_dashboard__5u4hM`,
	"dashboardContain": `CancelTicket_dashboardContain__lDty5`,
	"bodythemedark": `CancelTicket_bodythemedark__axtZ+`,
	"cont2": `CancelTicket_cont2__ylJGe`,
	"top_header": `CancelTicket_top_header__KiY54`,
	"top_header_inner": `CancelTicket_top_header_inner__gq7eq`,
	"subLink": `CancelTicket_subLink__O6Apd`,
	"cst_vendr": `CancelTicket_cst_vendr__vQtxw`,
	"form-control": `CancelTicket_form-control__8-XXQ`,
	"footer": `CancelTicket_footer__eIluR`,
	"bodythemelight": `CancelTicket_bodythemelight__nIVsX`,
	"headerthemelight": `CancelTicket_headerthemelight__yaWXB`,
	"headerthemedark": `CancelTicket_headerthemedark__gskBk`,
	"menuthemelight": `CancelTicket_menuthemelight__pFyrx`,
	"menuthemedark": `CancelTicket_menuthemedark__FLKi8`,
	"menulinklight": `CancelTicket_menulinklight__wNaRy`,
	"menulinkdarkSelected": `CancelTicket_menulinkdarkSelected__eHeIO`,
	"menulinklightSelected": `CancelTicket_menulinklightSelected__zI7uQ`,
	"menulinkdark": `CancelTicket_menulinkdark__AcoVg`,
	"sub_arrow": `CancelTicket_sub_arrow__dPOgf`,
	"headinglight": `CancelTicket_headinglight__sVw8v`,
	"headingdark": `CancelTicket_headingdark__1A3bA`,
	"searchboxlight": `CancelTicket_searchboxlight__2NXOZ`,
	"searchboxdark": `CancelTicket_searchboxdark__Yw5g-`,
	"tableheadlight": `CancelTicket_tableheadlight__3AERC`,
	"tableheaddark": `CancelTicket_tableheaddark__EHDr0`,
	"table": `CancelTicket_table__9ziVg`,
	"table-borderless": `CancelTicket_table-borderless__ka+8Y`,
	"left-section": `CancelTicket_left-section__SadkZ`,
	"tablebodylight": `CancelTicket_tablebodylight__2Vnzo`,
	"tablebodydark": `CancelTicket_tablebodydark__i0qez`,
	"paginationlight": `CancelTicket_paginationlight__8q10Q`,
	"paginationdark": `CancelTicket_paginationdark__Yt9pG`,
	"formthemelight": `CancelTicket_formthemelight__BO0Ab`,
	"formthemedark": `CancelTicket_formthemedark__4Tqq2`,
	"viewformlight": `CancelTicket_viewformlight__d8sZc`,
	"permissionboxlight": `CancelTicket_permissionboxlight__kA0ii`,
	"permissionboxdark": `CancelTicket_permissionboxdark__cpQUH`,
	"errormsgclr": `CancelTicket_errormsgclr__izXlI`,
	"graphclrlight": `CancelTicket_graphclrlight__78S0U`,
	"graphclrdark": `CancelTicket_graphclrdark__n-afR`,
	"card1bglight": `CancelTicket_card1bglight__SJ+Tr`,
	"card1bgdark": `CancelTicket_card1bgdark__0x5QL`,
	"card2bglight": `CancelTicket_card2bglight__MLD7R`,
	"card2bgdark": `CancelTicket_card2bgdark__l+WD4`,
	"card3bglight": `CancelTicket_card3bglight__xPDTA`,
	"card3bgdark": `CancelTicket_card3bgdark__mdySE`,
	"card4bglight": `CancelTicket_card4bglight__AHh8H`,
	"card4bgdark": `CancelTicket_card4bgdark__1bFJd`,
	"actionbtnlight": `CancelTicket_actionbtnlight__ghiRt`,
	"actionbtndark": `CancelTicket_actionbtndark__EdS2o`,
	"profiledropdownlight": `CancelTicket_profiledropdownlight__sLu3-`,
	"profiledropdowndark": `CancelTicket_profiledropdowndark__fNuaU`,
	"settingsection": `CancelTicket_settingsection__9VG0X`,
	"addform": `CancelTicket_addform__HhJeW`,
	"savebtn": `CancelTicket_savebtn__D9P0J`,
	"profile_conatiner": `CancelTicket_profile_conatiner__pDf8u`,
	"ag-theme-alpine": `CancelTicket_ag-theme-alpine__Z01Fn`,
	"ag-row": `CancelTicket_ag-row__c2V3B`,
	"formbtn": `CancelTicket_formbtn__9x1yB`,
	"resetbtn": `CancelTicket_resetbtn__c4aa5`,
	"addBtn": `CancelTicket_addBtn__oj2aE`,
	"addDltBtn": `CancelTicket_addDltBtn__uw17P`,
	"addbtnlight": `CancelTicket_addbtnlight__nnd0O`,
	"addbtndark": `CancelTicket_addbtndark__I3Kkk`,
	"cust_addBtn": `CancelTicket_cust_addBtn__-6R3s`,
	"deleteBtn": `CancelTicket_deleteBtn__JPuDy`,
	"confirmBtn": `CancelTicket_confirmBtn__5X7bu`,
	"delPopContainer": `CancelTicket_delPopContainer__Yem9O`,
	"modal-body": `CancelTicket_modal-body__JbOba`,
	"delet_icon": `CancelTicket_delet_icon__IWE4P`,
	"arrowback": `CancelTicket_arrowback__41BUk`,
	"drpdwn_btn": `CancelTicket_drpdwn_btn__ihqfw`,
	"empname": `CancelTicket_empname__GdUZM`,
	"navitemli": `CancelTicket_navitemli__ax5+M`,
	"tabnavli": `CancelTicket_tabnavli__Bqqe+`,
	"settingsgeneral": `CancelTicket_settingsgeneral__q0q+D`,
	"settingslinks": `CancelTicket_settingslinks__YUKYj`,
	"dropdown_menu_contain": `CancelTicket_dropdown_menu_contain__np6bz`,
	"dropdown_item": `CancelTicket_dropdown_item__XtxVr`,
	"profile_arrrow_dwn": `CancelTicket_profile_arrrow_dwn__yL0lK`,
	"dateinputbox1": `CancelTicket_dateinputbox1__G60Y-`,
	"modal-content": `CancelTicket_modal-content__UPBxN`,
	"larg_model": `CancelTicket_larg_model__556Ss`,
	"modal-dialog": `CancelTicket_modal-dialog__kI2UO`,
	"modal-header": `CancelTicket_modal-header__wxech`,
	"btn-primary": `CancelTicket_btn-primary__NFVZV`,
	"form-select": `CancelTicket_form-select__zIlix`,
	"CustomTable_tableheadlight__HuHZw": `CancelTicket_CustomTable_tableheadlight__HuHZw__bCAuL`,
	"CustomTable_tableheaddark__nwqb4": `CancelTicket_CustomTable_tableheaddark__nwqb4__-Y1DG`,
	"sectionright": `CancelTicket_sectionright__kaW6L`,
	"exer_modal_contain": `CancelTicket_exer_modal_contain__ol6zd`,
	"active_show_outer": `CancelTicket_active_show_outer__HWJTY`,
	"active_show_inner": `CancelTicket_active_show_inner__Qbsds`,
	"act_box_img": `CancelTicket_act_box_img__TB0Rm`,
	"act_box_cnt": `CancelTicket_act_box_cnt__W3sIa`,
	"act_box_bdg": `CancelTicket_act_box_bdg__lxxqb`,
	"sold": `CancelTicket_sold__bk14K`,
	"attent_details": `CancelTicket_attent_details__3aOQn`,
	"attent_details_inner": `CancelTicket_attent_details_inner__4myap`,
	"attent_details_inner_l": `CancelTicket_attent_details_inner_l__E0S30`,
	"attent_details_inner_r": `CancelTicket_attent_details_inner_r__fet33`,
	"attent_details_row": `CancelTicket_attent_details_row__AeKB-`,
	"attent_details_row_box": `CancelTicket_attent_details_row_box__0adcS`,
	"attent_details_row_last": `CancelTicket_attent_details_row_last__IAkGr`,
	"interesting_fact": `CancelTicket_interesting_fact__qfAsO`,
	"showbox_sec": `CancelTicket_showbox_sec__pwvwI`,
	"show_box_main": `CancelTicket_show_box_main__0tgty`,
	"show_box": `CancelTicket_show_box__WQXV-`,
	"no_show_box": `CancelTicket_no_show_box__RhYku`,
	"attent_flex": `CancelTicket_attent_flex__xBI9J`
};
export default ___CSS_LOADER_EXPORT___;
